import React from 'react';

import Paper from '@material-ui/core/Paper';
import { Grid } from '@material-ui/core';

import Input from '../../../../components/Input';

interface IProps {
  errors: {
    [key: string]: boolean;
  };
  values: any;
  setValue: (field: string) => (event: any) => void;
}

export const EventBasicsSection = (props: IProps) => {
  const { errors, values, setValue } = props;

  return (
    <Paper elevation={1} className="paper paper-full basics-stats">
      <h3>EVENT SETUP</h3>

      <Grid className="grid admin-form-field" container={true} spacing={0}>
        <Grid className="grid-item label" item={true} xs={10} sm={5} md={3}>
          <div>How many players in this event?</div>

          <div className={`sub ${errors.totalPlayers ? 'visible' : ''}`}>
            This must be at least one to publish the event
          </div>
        </Grid>

        <Grid className="grid-item input" item={true} xs={2} md={2}>
          <Input
            label=""
            defaultValue={values.totalPlayers}
            id="total-players"
            inputProps={{ min: 1 }}
            onChange={setValue('totalPlayers')}
            type="number"
            noIcon={true}
          />
        </Grid>
      </Grid>

      {/* Removing this to allow single round events only according to https://code.talpor.com/club15/frontend/-/issues/899 */}
      {/* <Grid className="grid admin-form-field" container={true} spacing={0}>
        <Grid className="grid-item label" item={true} xs={10} sm={5} md={3}>
          <div>How many rounds in this event?</div>
          <div className={`sub ${errors.totalRounds ? 'visible' : ''}`}>
            This must be at least one to publish the event
          </div>
        </Grid>
        <Grid className="grid-item input" item={true} xs={2} md={2}>
          <Input
            label=""
            defaultValue={values.totalRounds}
            id="total-rounds"
            inputProps={{ min: 1 }}
            onChange={setValue('totalRounds')}
            type="number"
            noIcon={true}
          />
        </Grid>
      </Grid> */}
    </Paper>
  );
};
